/**
 * Generates the AppsFlyer app download link.
 * @see {@link https://sweetgreen.atlassian.net/wiki/spaces/TD/pages/7042072584/AppsFlyer+Smart+Script}
 */
export const getAppsFlyerAppDownloadLink = () => {
  const appsFlyerWindow = window as unknown as AppsFlyerWindow;

  if (appsFlyerWindow.AF_SMART_SCRIPT_APP_DOWNLOAD_LINK) {
    return appsFlyerWindow.AF_SMART_SCRIPT_APP_DOWNLOAD_LINK;
  }

  const appsFlyerScript = appsFlyerWindow.AF_SMART_SCRIPT;

  if (!appsFlyerScript) return;

  const { clickURL: appsFlyerLink } = appsFlyerScript.generateOneLinkURL({
    oneLinkURL: ONE_LINK_URL,
    afParameters: APPS_FLYER_CONFIG,
  });

  // NOTE: Store the generated link globally so repeated consumer mounts do not regenerate it.
  appsFlyerWindow.AF_SMART_SCRIPT_APP_DOWNLOAD_LINK = appsFlyerLink;

  return appsFlyerLink;
};

// ─── Constants ───────────────────────────────────────────────────────────────

const ONE_LINK_URL = 'https://sweetgreen.onelink.me/VN9x';
const APPS_FLYER_CONFIG = {
  mediaSource: {
    defaultValue: 'default',
  },
  afCustom: [
    {
      paramKey: 'af_ss_ui',
      defaultValue: 'true',
    },
  ],
};

// ─── Types ───────────────────────────────────────────────────────────────────

type GenerateOneLinkURLParams = {
  oneLinkURL: string;
  afParameters: Record<string, unknown>;
};

type GenerateOneLinkURLResponse = {
  clickURL: string;
};

type AppsFlyerWindow = {
  AF_SMART_SCRIPT_APP_DOWNLOAD_LINK?: string;
  AF_SMART_SCRIPT?: {
    generateOneLinkURL: (params: GenerateOneLinkURLParams) => GenerateOneLinkURLResponse;
  };
};
